import { MEASUREMENT_UNIT } from 'src/constants/measurementUnits';
import IBundleGroup from 'src/types/IBundleGroup';

const hasBundleGroupUnit = (
  group: IBundleGroup,
  unit: MEASUREMENT_UNIT,
): boolean => group.name.includes(unit);

export default hasBundleGroupUnit;
